<template>
    <ion-page class="page-annotations">
        
        <!-- <ion-header>
            <ion-toolbar>
                <ion-title>Annotations Shared with You</ion-title>
            </ion-toolbar>
        </ion-header> -->

        <ion-content>
            <ion-list>
                <!-- Repeat shimmer items 10 times -->
                <ion-item v-for="n in 10" :key="n" detail="false" class="ion-text-wrap">
                    <div class="shimmer-item-container">
                        <!-- Title -->
                        <div class="shimmer-box title-line-shimmer"></div>
                        <!-- Subtitle -->	
                        <div class="shimmer-box subtitle-line-shimmer"></div>
                    </div>
                </ion-item>
            </ion-list>
        </ion-content>
    </ion-page>
</template>



<script>
export default {
    name: 'AnnotationsShimmer'
}
</script>

<style scoped>
.shimmer-box {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
}

@keyframes shimmer {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}

.shimmer-item-container {
    width: 100%;
    padding: 12px 0;
}

.title-line-shimmer {
    width: 180px;
    height: 30px;
    margin-bottom: 8px;
}

.subtitle-line-shimmer {
    width: 100%;
    height: 30px;
}

ion-item {
    --padding-start: 16px;
    --padding-end: 16px;
    --inner-padding-end: 0;
}
</style>